module.exports = __webpack_public_path__ + "img/PM_A01_back_de.452277dd.png";